var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrellaSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.375a1.125 1.125 0 01-2.25 0v-3M1.515 6.375a.376.376 0 01-.373-.408 4.875 4.875 0 019.716 0 .376.376 0 01-.374.408H1.515z",
    stroke: "#4E8278",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUmbrellaSimple;